import { CorrespondenceTeamDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CorrespondenceTeamService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCorrespondenceTeam(): Observable<CorrespondenceTeamDto[]> {
    return this.http.get<CorrespondenceTeamDto[]>(
      this.url + 'correspondence-team'
    );
  }

  createCorrespondenceTeam(
    data: CorrespondenceTeamDto[]
  ): Observable<CorrespondenceTeamDto[]> {
    return this.http.post<CorrespondenceTeamDto[]>(
      this.url + 'correspondence-team',
      data
    );
  }
  getSingleCorrespondenceTeam(id: string): Observable<any> {
    return this.http.get(this.url + 'correspondence-team/' + id);
  }

  updateCorrespondenceTeam(
    data: CorrespondenceTeamDto[]
  ): Observable<CorrespondenceTeamDto[]> {
    return this.http.post<CorrespondenceTeamDto[]>(
      this.url + 'correspondence-team/update',
      data
    );
  }

  deleteCorrespondenceTeam(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('correspondence-team', ids.join(', '));
    return this.http.delete(this.url + 'correspondence-team', httpOptions);
  }
}
